import React, { useState } from 'react'
import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery,
} from "@material-ui/core";

import Services from '../../Services';
import TextFieldComp from '../InputComponents/TextFieldComp';
import { formatPhoneNumber } from '../../helpers/formatedNumber';

const {
    hr,
 
} = Services;



const PhoneNumber = ({ modalData }) => {

    let { employeeDetails, open, close, mainFlag, setMainFlag } = modalData;
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [ErrorHome, setErrorHome] = useState(null)
    const [ErrorCell, setErrorCell] = useState(null)

    const [updateEmployeeDetails, setUpdateEmployeeDetails] = useState((updateEmployeeDetails) => ({ ...updateEmployeeDetails, homePhone: employeeDetails.homePhone, cellPhone: employeeDetails.cellPhone }));

    const setError = (value , setError ) => {
        if(checkObjectLength({value}, 14)){
            return setError(null)
        } else {
            return setError("Length should be atleast 10 digits")
        }
    }
    const onChangeEditPhoneNumber = (value, e) => {
        let formatted = formatPhoneNumber(value)
        e.target.value = formatted
        setUpdateEmployeeDetails({ ...updateEmployeeDetails, homePhone: formatted })
        setError(formatted , setErrorHome);
    }

    const onChangeEditCellPhone = (value, e) => {
        let formatted = formatPhoneNumber(value)
        e.target.value = formatted
        setUpdateEmployeeDetails({ ...updateEmployeeDetails, cellPhone: formatted })
        if(formatted?.length)
            setError(formatted , setErrorCell);
        else 
            setErrorCell(null)
    }

    const checkObjectLength = (obj, length) => {
        let flag = true;
        Object.keys(obj).forEach((key) => {
            if (obj[key].length < length) flag = false;
        })
        return flag
    }


    function onUpdateContact(e) {
        e.preventDefault();

        setError(updateEmployeeDetails?.homePhone , setErrorHome);


        if (updateEmployeeDetails?.cellPhone)
            setError(updateEmployeeDetails?.cellPhone , setErrorCell)
        
        if(ErrorHome != null || (ErrorCell !=null && updateEmployeeDetails?.cellPhone))
            return             

        let data = {
            homePhone: updateEmployeeDetails?.homePhone,
            cellPhone: updateEmployeeDetails?.cellPhone,
            id: employeeDetails.id
        }
        try {

            hr.updateEmployeeDetails(data).then((certificateData) => {
                setMainFlag(!mainFlag)
                close(false);
            }).catch((err) => {   })
        }
        catch (exc) {

             

        }
    }

    let fields = [
        { name: "Home Phone", initial: updateEmployeeDetails.homePhone, isRequired: true, onChange: onChangeEditPhoneNumber, validation: ErrorHome },
        { name: "Cell Phone", initial: updateEmployeeDetails.cellPhone, isRequired: false, onChange: onChangeEditCellPhone, validation: ErrorCell },
    ]



    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={() => close(false)}
            className="BroadcastMessageModal LiqTables"
            aria-labelledby="responsive-dialog-title"
        >
            <Button autoFocus onClick={() => close(false)} className="ModalClose">
            </Button>
            <DialogContent>
                <form onSubmit={onUpdateContact}>
                    <TextFieldComp fields={fields} />
                    <Grid xs={12} container justify="center" className="mt30">
                        <Button type="submit" className="LinkButton">Save</Button>
                    </Grid>
                </form>
            </DialogContent>
        </Dialog>
    )
}

export default PhoneNumber